import React from 'react';
import { getSourceHref } from '../../utils/urls';

interface LinkProps {
  url: string;
  target?: string;
  addHttps?: boolean;
}

const CustomLink: React.FC<LinkProps> = ({ url, target = 'self', addHttps = false }) => {
  const rawHref = addHttps ? `https://${url}` : url;
  return (
    <a href={getSourceHref(rawHref)} target={target}>
      {url}
    </a>
  );
};

export default CustomLink;
